import { appStorage } from './betaStorage'
import { localISODate } from './date'
import { loadRoutines, saveRoutines, type Routine } from './dailyLiving'
import { getSelectedYouthParticipant, setSelectedYouthParticipant, youthParticipantProfiles, type YouthParticipantId } from './youthParticipants'
import type { TaskItem } from '../types'

export const YOUTH_DEMO_PROFILE_KEY = 'schub.demoYouthProfile'
export const youthDemoProfiles = youthParticipantProfiles

export const youthDemoProfile = {
  get id() { return getSelectedYouthParticipant().id },
  get name() { return getSelectedYouthParticipant().name },
  get age() { return getSelectedYouthParticipant().age },
  get photoUrl() { return getSelectedYouthParticipant().photoUrl },
}

export function isYouthDemoProfile() {
  try {
    return appStorage.getItem(YOUTH_DEMO_PROFILE_KEY) === '1'
  } catch {
    return false
  }
}

export function setYouthDemoProfile(enabled: boolean, participantId?: YouthParticipantId) {
  if (participantId) setSelectedYouthParticipant(participantId)
  if (enabled) appStorage.setItem(YOUTH_DEMO_PROFILE_KEY, '1')
  else appStorage.removeItem(YOUTH_DEMO_PROFILE_KEY)
}

const youthDemoTasks: TaskItem[] = [
  {
    id: 'youth-demo-task-bag',
    title: 'Pack my school bag',
    assignedToUserId: 'u-leo',
    assignedByUserId: 'u-lillian',
    dueDate: localISODate(),
    priority: 'medium',
    status: 'todo',
    createdAt: new Date().toISOString(),
  },
  {
    id: 'youth-demo-task-break',
    title: 'Practise asking for a break',
    assignedToUserId: 'u-leo',
    assignedByUserId: 'u-mia',
    dueDate: localISODate(),
    priority: 'medium',
    status: 'todo',
    createdAt: new Date().toISOString(),
  },
  {
    id: 'youth-demo-task-headphones',
    title: 'Put my headphones in my bag',
    assignedToUserId: 'u-leo',
    assignedByUserId: 'u-lillian',
    dueDate: localISODate(),
    priority: 'medium',
    status: 'todo',
    createdAt: new Date().toISOString(),
  },
  {
    id: 'jnr-demo-task-break',
    title: 'Practise choosing help or a break',
    assignedToUserId: 'u-jnr',
    assignedByUserId: 'u-lillian',
    dueDate: localISODate(),
    priority: 'medium',
    status: 'todo',
    createdAt: new Date().toISOString(),
  },
  {
    id: 'jnr-demo-task-play',
    title: 'Complete my two-step play routine',
    assignedToUserId: 'u-jnr',
    assignedByUserId: 'u-lillian',
    dueDate: localISODate(),
    priority: 'low',
    status: 'todo',
    createdAt: new Date().toISOString(),
  },
]

const youthMorningRoutine: Routine = {
  id: 'youth-demo-morning-routine',
  title: 'My Morning Routine',
  category: 'Morning',
  style: 'visual',
  repeat: 'daily',
  selectedDays: [],
  createdByUserId: 'u-lillian',
  createdAt: new Date().toISOString(),
  steps: [
    { id: 'youth-morning-toilet', text: 'Go to the toilet', icon: '🚽', done: false },
    { id: 'youth-morning-dress', text: 'Get dressed', icon: '👕', done: false },
    { id: 'youth-morning-breakfast', text: 'Eat breakfast', icon: '🥣', done: false },
    { id: 'youth-morning-teeth', text: 'Brush my teeth', icon: '🪥', done: false },
    { id: 'youth-morning-bag', text: 'Pack my bag', icon: '🎒', done: false },
    { id: 'youth-morning-shoes', text: 'Put on my shoes', icon: '👟', done: false },
  ],
}

export function ensureYouthDemoContent(existingTasks: TaskItem[], addTask: (task: TaskItem) => void) {
  youthDemoTasks.forEach((task) => {
    if (!existingTasks.some((existing) => existing.id === task.id)) addTask(task)
  })

  const routines = loadRoutines()
  if (!routines.some((routine) => routine.id === youthMorningRoutine.id)) {
    saveRoutines([youthMorningRoutine, ...routines])
  }
}

